import React from "react"
import {Anchor} from "../../component"

export type LinkProps = {
    url: string | null
    text: string | null
}

export const SecureHelpLink = ({text, url}: LinkProps) =>
    url && text ? (
        <Anchor data-testid="header-secure-help-link" className="header-secure-help-link" href={url}>
            {text}
        </Anchor>
    ) : null

export default SecureHelpLink
